import React from "react";
import {
  EditorShortcutProviderProps,
  EditorShortcutState,
} from "./EditorShortcutContext.types";

export const EditorShortcutContext = React.createContext<
  EditorShortcutState | undefined
>(undefined);

export const EditorShortcutProvider: React.FC<EditorShortcutProviderProps> = ({
  children,
  defaultShortcuts,
}) => {
  const [shortcuts] = React.useState(defaultShortcuts);
  return (
    <EditorShortcutContext.Provider value={{ shortcuts }}>
      {children}
    </EditorShortcutContext.Provider>
  );
};
